module.exports = __webpack_public_path__ + "static/media/Lotto5.0d87b425.jpg";